import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScienceService } from '../science.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.css'
})
export class ChatComponent implements OnInit {
  messages: { name: string, message: string }[] = [];
  messageText: string = '';
  isChatOpen: boolean = false;
  isLoggedIn = false;
  header?: HTMLElement;
  menubtn?: HTMLElement;
  menu?: HTMLElement;
  icon?: HTMLElement;
  scrollbtn?: HTMLElement;
  constructor(
    private scienceService: ScienceService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  sendMessage(): void {
    if (this.messageText.trim()) {
      this.messages.push({ name: 'User', message: this.messageText });

      this.scienceService.sendMessage(this.messageText).subscribe(response => {
        this.messages.push({ name: 'Sam', message: response.response });
        this.messageText = '';
      });
    }
  }


  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  toggleChat(): void {
    this.isChatOpen = !this.isChatOpen;
  }
}
